import { DeleteOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "@mui/material";

import React, { useState } from "react";
import infoIcon from "../../../../../assets/images/info_icon.svg";
import specialOnboardingIcon from "../../../../../assets/images/special-onboarding-icon.svg";
import {
  ClearanceStatus,
  getStatusInfo,
  REJECT_REASONS
} from "../../../../../utils/constants";
import { getAirportData } from "../../../../../utils/utils";
import "../EditFlightRoster.css";

const EditFlightSpecialOnboarding = ({
  isAddedSpecialOnboarding,
  addSpecialOnboarding,
  deleteEscortService,
  tripStatus,
  arrivalEscortStatus,
  departureEscortStatus,
  airportData,
  arrivalAirport,
  departureAirport,
  arrivalRejectionReason,
  departureRejectionReason,
  hasDepartureTerminal,
  hasArrivalTerminal,
}) => {
  const escortArrivalStatus =
    arrivalEscortStatus === ClearanceStatus.NOT_REQUIRED
      ? null
      : arrivalEscortStatus;
  const escortDepartureStatus =
    departureEscortStatus === ClearanceStatus.NOT_REQUIRED
      ? null
      : departureEscortStatus;

  const departureAirportData = getAirportData(airportData, departureAirport);
  const arrivalAirportData = getAirportData(airportData, arrivalAirport);

  const { text: arrivalStatusText } = getStatusInfo(escortArrivalStatus);
  const { text: departureStatusText } = getStatusInfo(escortDepartureStatus);

  const getRejectionReasonLabel = (value) => {
    const option = REJECT_REASONS.find((opt) => opt.value === value);
    return option ? option.label : value;
  };

  const [departureTooltipOpen, setDepartureTooltipOpen] = useState(false);
  const [arrivalTooltipOpen, setArrivalTooltipOpen] = useState(false);

  const renderStatusWithIcon = (
    code,
    status,
    rejectionReason,
    isArrival = false
  ) => {
    const statusType = isArrival ? escortArrivalStatus : escortDepartureStatus;
    const { className } = getStatusInfo(statusType);

    return (
      <p className="status-p">
        {code} •{" "}
        <span className={`status-with-icon-${className}`}>
          {status}
          {status === "Cancelled" && rejectionReason != null && (
            <Tooltip
              title={getRejectionReasonLabel(rejectionReason)}
              arrow
              open={isArrival ? arrivalTooltipOpen : departureTooltipOpen}
              onClose={() =>
                isArrival
                  ? setArrivalTooltipOpen(false)
                  : setDepartureTooltipOpen(false)
              }
              onClick={(e) => {
                e.stopPropagation();
                if (isArrival) {
                  setArrivalTooltipOpen(!arrivalTooltipOpen);
                  setDepartureTooltipOpen(false);
                } else {
                  setDepartureTooltipOpen(!departureTooltipOpen);
                  setArrivalTooltipOpen(false);
                }
              }}
              onTouchEnd={(e) => {
                e.stopPropagation();
                if (isArrival) {
                  setArrivalTooltipOpen(!arrivalTooltipOpen);
                  setDepartureTooltipOpen(false);
                } else {
                  setDepartureTooltipOpen(!departureTooltipOpen);
                  setArrivalTooltipOpen(false);
                }
              }}
            >
              <img src={infoIcon} alt="info" className="status-info-icon" />
            </Tooltip>
          )}
        </span>
      </p>
    );
  };

  // Check if terminal selection blocks special onboarding
  // Only block if terminal is selected AND the airport has escort fee enabled
  const isDepartureEscortAvailable = departureAirportData?.escortFeeEnabled && !hasDepartureTerminal;
  const isArrivalEscortAvailable = arrivalAirportData?.escortFeeEnabled && !hasArrivalTerminal;

  // Hide the Add button only if ALL airports with escort fee enabled have terminals selected
  // Show Add button if at least one airport allows special onboarding
  const canAddSpecialOnboarding = isDepartureEscortAvailable || isArrivalEscortAvailable;
  const showAddButton = canAddSpecialOnboarding || isAddedSpecialOnboarding;

  return (
    <div className="edit-flight-details-sub-container">
      <div className="edit-flight-special-onboarding-container edit-flight-special-onboarding-vertical">
        <div className="edit-flight-special-onboarding-header-row">
          <div className="edit-flight-special-onboarding-title-container">
            <img src={specialOnboardingIcon} alt="special-onboarding" />
            <p>Special Onboard Screening</p>
          </div>
          {tripStatus !== ClearanceStatus.CANCELLED && showAddButton && (
            <div className="edit-flight-special-onboarding-button-container">
              <Button
                variant="contained"
                onClick={() =>
                  addSpecialOnboarding(
                    isAddedSpecialOnboarding ? "edit" : "add"
                  )
                }
              >
                {isAddedSpecialOnboarding ? "View" : "Add"}
              </Button>

              {isAddedSpecialOnboarding && (
                <div className="edit-flight-special-onboarding-delete-button-container">
                  <DeleteOutlined
                    className="edit-flight-special-onboarding-delete-button"
                    onClick={deleteEscortService}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <div className={`edit-flight-special-onboarding-status`}>
          {escortDepartureStatus != null &&
            renderStatusWithIcon(
              departureAirportData?.name,
              departureStatusText,
              departureRejectionReason,
              false
            )}
          {escortArrivalStatus != null &&
            renderStatusWithIcon(
              arrivalAirportData?.name,
              arrivalStatusText,
              arrivalRejectionReason,
              true
            )}
        </div>
      </div>
    </div>
  );
};

export default EditFlightSpecialOnboarding;
